import React, { useState }  from 'react'
export default function ABC() {
    const [abc, setABC] = useState(false)
      return (
        <>
          <button className='plane-btn' onClick={() => setABC(!abc)}>{abc ? <>▲</>:<>▼</>}</button><br/>
          {abc ? <>display</>:''}
        </>
      )
  }